<template>
  <div id="js-4-mat-view">
    <v-container v-if="!assessment.quadrant">
      <v-row class="d-flex justify-center">
        <span class="assessment-text assessment-description">
          You may have heard of different learning styles before, and even have
          an idea of how you learn best. For instance maybe you are a “visual”
          learner and prefer to see something happen in order to understand a
          concept. The learning style assessment we use is slightly different
          and takes a detailed look into the way you approach learning in all
          aspects of life. The assessment we use for this is called the 4MAT
          Learning Type Measure (LTM). The 4MAT assesses how individuals
          approach information and evaluates their natural learning style –
          which ranges from research heavy, to needing some context.
        </span>
      </v-row>
      <v-row class="d-flex justify-center">
        <span class="assessment-text assessment-mentor-message">
          Your Mentor will work with you on when to take this assessment!
        </span>
      </v-row>
    </v-container>
    <div class="graphic">
      <four-mat-chart :data="assessment"></four-mat-chart>
    </div>
    <div>
      <four-mat-text1 v-if="assessment.quadrant == 1"></four-mat-text1>
      <four-mat-text2 v-if="assessment.quadrant == 2"></four-mat-text2>
      <four-mat-text3 v-if="assessment.quadrant == 3"></four-mat-text3>
      <four-mat-text4 v-if="assessment.quadrant == 4"></four-mat-text4>
    </div>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import FourMatChart from "@/components/assessments/FourMatChart"
import FourMatText1 from "@/components/assessments/FourMatText1"
import FourMatText2 from "@/components/assessments/FourMatText2"
import FourMatText3 from "@/components/assessments/FourMatText3"
import FourMatText4 from "@/components/assessments/FourMatText4"

import User from "@/lib/user"
import { mapGetters } from "vuex"

export default {
  mixins: [titleMixin],
  components: {
    FourMatChart,
    FourMatText1,
    FourMatText2,
    FourMatText3,
    FourMatText4
  },
  data: function() {
    return {
      title: "Learning Style",
      userId: User.getUserId(),
      assessment: {}
    }
  },
  created() {
    let ass = this.getAssessmentByType("4-Mat")
    this.assessment = ass ? ass : {}
  },
  methods: {
    getAssessmentByType(type) {
      return this.assessments
        ? this.assessments.find(el => el.type == type)
        : {}
    }
  },
  computed: {
    ...mapGetters("assessments", ["getAssessmentsByUserId"]),
    assessments() {
      if (this.getAssessmentsByUserId(this.userId)) {
        return this.getAssessmentsByUserId(this.userId).assessments
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/assessment-text";

.graphic {
  width: 100%;
  margin: 0px auto;
  max-width: 600px;
}
</style>
